import { Link } from "@tanstack/react-router";
import { SectionMark } from "@/components/section-mark";
import { cta } from "@/lib/analytics";

export function OfferSection() {
  return (
    <section id="oferta" className="content-visibility-auto scroll-mt-24 border-b border-ink/10 bg-surface">
      <div id="konsultacje" className="container-page section-pad scroll-mt-24">
        <div className="grid gap-8 md:grid-cols-2 md:gap-12 lg:gap-16">
          <div>
            <SectionMark number="08" label="Oferta" />
            <h2 className="display-xl mt-8 text-[1.9rem] md:text-[2.4rem]">
              Wolisz pracować indywidualnie?
            </h2>
          </div>
          <div className="min-w-0 md:pt-16">
            <div className="h-px w-full bg-steel" />
            <p className="measure-text mt-6 text-base leading-relaxed text-ink/80 md:text-lg">
              Poufna praca nad konkretną sytuacją, trudną decyzją albo powtarzającymi się
              sposobami reagowania.
            </p>
            <div className="mt-8">
              <Link
                to="/konsultacje"
                {...cta("konsultacje", "oferta", "konsultacja")}
                className="btn-base btn-primary inline-flex min-h-11 items-center justify-center"
              >
                Poznaj konsultacje
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
